<template>
  <div>
  </div>
</template>

<script>
// import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'LoginByPass',

  mounted () {
    // console.log('TCL: beforeMount -> this.$router', this.$route);
    if (this.$route.name === 'LoginByPass') {
      let destinationUrl = '/';
      if (this.$route.query && this.$route.query.path_redirect) {
        destinationUrl = this.$route.query.path_redirect;
      }
      if (this.$route.params.token) {
        axios.defaults.headers.common.Authorization = `JWT ${this.$route.params.token}`;
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        axios.post(`${process.env.VUE_APP_API_URL}saml_auth/sso-redirect-login/`, {
          user_id: this.$route.params.usrt
        }).then((response) => {
          if (response.data) {
            response.data.userType = 'sso';
            this.$store.dispatch('createSession', response.data);
            this.$router.push({ path: destinationUrl });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'There was some error!'
            });
          }
        }, (res) => {
          if (res.status === 401) {
            this.$store.dispatch('updateStatusSsoUser', res.status);
          } else if (res.status !== 401) {
            this.$store.dispatch('updateStatusSsoUser', res.status);
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'There was some error!'
            });
          }
        });
      }
    }
  }
};
</script>
